<script>
import moment from 'moment';
import Layout from "../../layouts/main";
import DatePicker from "vue2-datepicker";
import 'vue2-datepicker/locale/pt-br';
import appConfig from "@/app.config";

import SaleService from '@/services/sale'
import CrmService from '@/services/crm'

moment.locale('pt-BR');

export default {
  page: {
    title: "Histórico de Pedidos",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, DatePicker },
  data() {
    return {
      title: "Histórico de Pedidos",
      loading: false,
      sales: [],
      sellers: [],
      searchParams: {
        code: '',
        customer: '',
        seller: '',
        startDate: '',
        endDate: '',
        period: true,
        attendanceCode: '',
      },
      count: 0,
      currentCount: 0,
      currentPage: 1,
      totalPages: 0,
      perPage: 0,
      startIndex: 0,
      endIndex: 0,

      totalSales: 0,
      totalCanceledSales: 0,
      totalValidSales: 0,

      fields: [
        { key: 'attendanceCode', sortable: true, label: 'Origem', formatter: (value) => {
          if (value === 5) {
            return 'APP'
          }

          if (value === 6) {
            return 'WEB'
          }

          return 'MOB';
        } },
        { key: 'companyName', sortable: true, label: 'Filial' },
        { key: 'exportedCode', sortable: true, label: 'Nº Pedido' },
        { key: 'customerName', sortable: true, label: 'Cliente' },
        { key: 'customer.group', sortable: true, label: 'Tipo', formatter: (value) => {
          return value || 'BIKE'
        } },
        { key: 'customerState', sortable: true, label: 'UF' },
        { key: 'customerCity', sortable: true, label: 'Cidade' },
        { key: 'statusDescription', sortable: true, label: 'Status' },
        { key: 'sellerName', sortable: true, label: 'Vendedor' },
        { key: 'paymentConditionDescription', sortable: true, label: 'Cond. Pagto.' },
        { key: 'date', sortable: true, label: 'Emissão', formatter: (value) => {
            return moment(value).format('DD/MM/YYYY HH:mm:ss');
          }
        },
        { key: 'totalValue', sortable: true, label: 'R$ Total', class: 'nowrap-col', formatter: (value) => {
            return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
          }
        },
        { key: 'actions', label: '', class: 'nowrap-col' }
      ],

      itemsFields: [
        { key: 'sequence', sortable: true, label: 'Item' },
        { key: 'product.code', sortable: true, label: 'Código' },
        { key: 'product.description', sortable: true, label: 'Produto' },
        { key: 'quantity', sortable: true, label: 'Qtde.' },
        { key: 'price', sortable: true, label: 'Valor Unitário', formatter: (value, key, item) => {
          return (item.price).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        } },
        { key: 'total', sortable: true, label: 'Valor Total', formatter: (value, key, item) => {
          return (item.quantity * item.price).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        } }
      ]
    };
  },
  mounted() {
    const now = new Date();
    const startDate = new Date();
    startDate.setDate(startDate.getDate() - 7);

    this.searchParams.startDate = startDate;
    this.searchParams.endDate = now;

    this.loadSellers();
    this.search();
  },
  computed: {
    isSellerMaster() {
      return this.$store.getters.userData?.seller?.type === 'VO';
    }
  },
  methods: {
    loadSellers() {
      CrmService.getAllActiveSellers().then(res => {
        this.sellers = res.data;
      }).catch(() => {})
    },
    search() {
      this.loadSales();
    },
    loadSales(page = 1) {
      this.loading = true;

      if (!this.searchParams.startDate) {
        if (!this.searchParams.endDate) {
          this.searchParams.endDate = new Date();
        }
        
        const startDate = new Date(this.searchParams.endDate);
        startDate.setDate(startDate.getDate() - 7);
        this.searchParams.startDate = startDate;
      }

      if (!this.searchParams.endDate) {
        this.searchParams.endDate = new Date();
      }

      SaleService.getOrders(this.searchParams, page)
        .then(res => {
          this.loading = false;

          this.sales = res.data.sales;
          this.count = res.data.count;
          this.currentCount = res.data.currentCount;
          this.currentPage = res.data.currentPage;
          this.totalPages = res.data.totalPages;
          this.perPage = res.data.perPage;
          this.startIndex = res.data.startIndex;
          this.endIndex = res.data.endIndex;

          this.totalSales = res.data.totalSales;
          this.totalCanceledSales = res.data.totalCanceledSales;
          this.totalValidSales = res.data.totalValidSales;
        })
      .catch(() => {
        this.loading = false;
      })
    },
    onPageChange() {
      window.scrollTo(0,0);
      this.loadSales(this.currentPage);
    },
    openOrder(sale) {
      this.$store.dispatch('OPEN_ORDER', {
        cartId: sale._id,
        customerId: sale.customer._id,
        companyId: sale.company._id,
      })

      this.$router.push({ name: "products" })
    },
    exportData() {
      this.loading = true;

      SaleService.exportOrders(this.searchParams).then(res => {
        this.loading = false;
        
        var fileURL = window.URL.createObjectURL(new Blob([res.data]));
        var fileLink = document.createElement('a');

        fileLink.href = fileURL;
        fileLink.setAttribute('download', 'HistoricoPedidos.xlsx');
        document.body.appendChild(fileLink);

        fileLink.click();
      }).catch(() => {
        this.loading = false;
      })
    }
  }
};
</script>

<template>
  <Layout>
    <div class="row">
      <div class="col-12">
        <div class="page-title-box d-flex align-items-center justify-content-between">
          <h4 class="mb-0 font-size-18">{{title}}</h4>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <form @submit.prevent="search" class="align-items-center">
              <div class="row">
                <div class="col-lg-6 col-sm-12">
                  <div class="form-group">
                    <div class="row">
                      <div class="col-8">
                        <label>Número do Pedido</label>
                        <input type="text" v-model="searchParams.code" class="form-control" placeholder="Informe o número do pedido" />
                      </div>

                      <div class="col-4">
                        <label>Origem</label>
                        <select class="form-control" v-model="searchParams.attendanceCode">
                          <option value="">TODOS</option>
                          <option value="mob">MOB</option>
                          <option value="web">WEB</option>
                          <option value="app">APP</option>
                        </select>
                      </div>
                    </div>
                  </div>

                  <div class="form-group">
                    <div class="row">
                      <div :class="isSellerMaster ? 'col-8' : 'col-12'">
                        <label>Cliente</label>
                        <input type="text" v-model="searchParams.customer" class="form-control" placeholder="Informe o nome do cliente" />
                      </div>

                      <div class="col-4" v-if="isSellerMaster">
                        <label>Vendedor</label>
                        <select class="form-control" v-model="searchParams.seller">
                          <option value="">TODOS</option>
                          <option v-for="seller in sellers" :key="seller._id" :value="seller._id">{{ seller.name }}</option>
                        </select>
                      </div>
                    </div>
                  </div>

                  <div class="custom-control custom-checkbox mb-2">
                    <input type="checkbox" class="custom-control-input" id="customCheck1" v-model="searchParams.period" />
                    <label class="custom-control-label" for="customCheck1">Período</label>
                  </div>
                  
                  <div class="row">
                    <div class="col-6">
                      <div class="form-group mb-3">
                        <!-- <label>Período de</label> -->
                        <date-picker
                          v-model="searchParams.startDate"
                          :first-day-of-week="1"
                          format="DD/MM/YYYY"
                          lang="pt-br"
                          :disabled="!searchParams.period"
                        ></date-picker>
                      </div>
                    </div>

                    <div class="col-6">
                      <div class="form-group mb-3">
                        <!-- <label>até</label> -->
                        <date-picker
                          v-model="searchParams.endDate"
                          :first-day-of-week="1"
                          format="DD/MM/YYYY"
                          lang="pt-br"
                          :disabled="!searchParams.period"
                        ></date-picker>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="button-search">
                <b-button type="submit" variant="primary" v-if="!loading">Filtrar</b-button>
                <b-button class="ml-2" variant="outline-primary" @click="exportData" v-if="!loading">Exportar</b-button>
                <a href="javascript:void(0);" class="text-primary" v-if="loading">
                  <b-spinner class="ml-2" variant="primary" role="status"></b-spinner>
                </a>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body"> 
            <div class="table-responsive mb-0">
              <b-table
                show-empty
                emptyText="Nenhum registro para exibir"
                :items="sales"
                :fields="fields"
                responsive="sm"
                head-variant="light"
              >
                <template v-slot:cell(statusDescription)="row">
                  <span
                    class="badge badge-pill badge-soft-primary font-size-12"
                    :class=" {
                      'badge-soft-warning': row.item.status === 'processing',
                      'badge-soft-info': row.item.status === 'separation',
                      'badge-soft-danger': row.item.status === 'canceled',
                      'badge-soft-secondary': row.item.status === 'billed'
                    }"
                  >{{row.item.statusDescription}}</span>
                </template>
                
                <template v-slot:cell(actions)="row">
                  <a href="javascript:void(0);" class="action-icon text-success mr-3" @click="row.toggleDetails">
                    <i class="mdi mdi-eye font-size-18"></i>
                  </a>
                </template>

                <template v-slot:row-details="row">
                  <b-table
                    bordered
                    small
                    :items="row.item.items"
                    :fields="itemsFields"
                    responsive="sm"
                  >
                  </b-table>
                </template>

                <template slot="bottom-row">
                  <td colspan="6"></td>
                  <td colspan="2" class="text-left nowrap-col">
                    <p>Total de Pedidos:</p>
                    <p>Cancelados:</p>
                    <strong>Valor Total:</strong>
                  </td>
                  <td colspan="3" class="text-left nowrap-col">
                    <p><strong>R$ {{totalSales | currency}}</strong></p>
                    <p><strong>- R$ {{totalCanceledSales | currency}}</strong></p>
                    <h4 class="m-0">R$ {{totalValidSales | currency}}</h4>
                  </td>
                </template>
              </b-table>
            </div>
          </div>
        </div>

        <div class="row justify-content-md-between align-items-md-center mt-4">
          <div class="col-xl-7">Mostrando {{startIndex}} - {{endIndex}} de {{count}}</div>
          <!-- end col-->
          <div class="col-xl-5">
            <div class="text-md-right float-xl-right mt-2 pagination-rounded">
              <b-pagination
                v-model="currentPage" 
                :total-rows="count"
                :per-page="perPage"
                @input="onPageChange"
              ></b-pagination>
            </div>
          </div>
          <!-- end col-->
        </div>
      </div>
    </div>
  </Layout>
</template>


<style lang="scss">
  .button-search {
    display: flex;
    align-items: center;
  }

  .mx-input:disabled {
    background-color: #e8e8e8 !important;
  }

  .nowrap-col {
    white-space: nowrap;
  }
</style>